import React, {
  ReactNode,
  useCallback,
  useContext,
  useState,
} from 'react';
import { createContext } from 'react';

interface IAppContext {
  isSideNavbarOpen: boolean;
  toogleIsSideNavbarOpen: () => void;
}

const AppContext = createContext({} as IAppContext);

export const useAppContext = () => {
  return useContext(AppContext);
};

export const AppProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [isSideNavbarOpen, setIsSideNavbarOpen] = useState(false);

  const toogleIsSideNavbarOpen = useCallback(() => {
    setIsSideNavbarOpen((oldSideNavbarOpen) =>
      !oldSideNavbarOpen
    );
  }, []);

  return (
    <AppContext.Provider value={{ isSideNavbarOpen, toogleIsSideNavbarOpen }}>
      {children}
    </AppContext.Provider>
  );
};
